export enum LabelPositions {
  RIGHT_RIGHT = 'right-right',
  RIGHT_LEFT = 'right-left',
  LEFT_LEFT = 'left-left',
  LEFT_RIGHT = 'left-right',
  BOTTOM = 'bottom',
  TOP = 'top',
}
